import { Configuration } from './generated';
import axios from 'axios';

function getApiURL() {
	return process.env.VUE_APP_API_URL;
}

export const defaultAxiosInstance = axios.create({
	baseURL: getApiURL(),
	withCredentials: true,
});

setAuthToken(localStorage.getItem('token'));

export function setAuthToken(token) {
	if (token) {
		defaultAxiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
	}
}

export const defaultBasePath = '/api';
export const getDefaultConfiguration = (configuration?: Configuration): Configuration => {
	return configuration ? configuration : new Configuration();
};

export default {
	config: getDefaultConfiguration,
	axios: defaultAxiosInstance,
	basePath: defaultBasePath,
};
